import { Col, Row, Tabs } from 'antd';
import clsx from 'clsx';

import { FieldByType } from 'components';

import { useMemoState } from 'hooks';

import { enFields, frFields } from './displayOptionsHelpers';
import { RetailersSelect } from './RetailersSelect';
import { ZoneSelect } from './ZoneSelect';

import './DisplayOptions.styles.scss';

interface IDisplayOptionsProps {
  enNotFilled: boolean;
  frNotFilled: boolean;
}

export const DisplayOptions = ({
  enNotFilled,
  frNotFilled,
}: IDisplayOptionsProps) => {
  const [activeTab, setActiveTab] = useMemoState('1');

  const isEnRequired = enNotFilled && activeTab === '2';
  const isFRRequired = frNotFilled && activeTab === '1';

  return (
    <Row>
      <Col xs={18} xl={16}>

        <RetailersSelect />

        <ZoneSelect />

        <Tabs
          onChange={setActiveTab}
          activeKey={activeTab}
          className='mt-5'
          items={[{
            key: '1',
            label: <span className={clsx(isEnRequired && 'text-[red]')}>1. English</span>,
            children: (
              enFields.map((field) => (
                <FieldByType
                  key={field.label as string}
                  field={field}
                />
              ))
            ),
          }, {
            key: '2',
            forceRender: true,
            label: <span className={clsx(isFRRequired && 'text-[red]')}>2. French</span>,
            children: (
              frFields.map((field) => (
                <FieldByType
                  key={field.label as string}
                  field={field}
                />
              ))
            ),
          }]}
        />
      </Col>
    </Row>
  );
};
